import { Component, OnInit, Input, EventEmitter, Output, ViewChild } from '@angular/core';
import { JobComment } from '@app/model/jobComment';
import { JobCommentService } from '@app/services/jobComment.service';
import { QueryOptions } from '@app/model/query-options';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { LazyLoadEvent, SortEvent } from 'primeng/api/public_api';
import { ToastModule } from 'primeng/toast';
import { JobCommentServiceGet } from '@app/services/jobCommentGet.service';
import { NgForm } from '@angular/forms';
import { Messages } from '@app/constants/constant';
import { AuthenticationService } from '@app/services/authentication.service';
import { User } from '@app/model/user';

@Component({
  selector: 'app-job-comments',
  templateUrl: './job-comments.component.html',
  styleUrls: ['./job-comments.component.css']
})
export class JobCommentsComponent implements OnInit {
  records: any[];
  columns: any[];
  totalRecords: number;
  newJobComment: JobComment;
  inputComment: string;
  pageSize: number = 200;
  first: number = 0;
  showCrossIcon = true;
  showErrorMessage: boolean;
  showCloseIcon() {
    this.showCrossIcon = false
  };

  @Input() display: boolean;
  @Input() fields: any;
  @Output() displayFunction = new EventEmitter<boolean>();
  @Output() reloadTable = new EventEmitter<boolean>();
  currentUser :User;
  
  constructor(private _jobCommentService: JobCommentService,
    private _router: Router,
    private _toastService: MessageService,
    private _jobCommentServiceGet: JobCommentServiceGet,
    private  _authenticationService: AuthenticationService) { }
  @ViewChild('jobCommentForm', { static: false }) public jobCommentForm: NgForm;
  jobComment:any={ 
    comment:'',
  }

  ngOnInit() {
    this.columns = [
      { field: 'description', header: 'comments' },
      { field: 'updatedOn', header: 'UpdatedOn' },
      { field: 'user.firstName', header: 'UpdatedOn' },
    ];
    this.onLoad();
  }

  //  textAreaEmpty(){
  //   this.showErrorMessage=this.jobCommentForm.value.comments.trim().length === 0?true :false;
  //  }
  
  createJobComment = function (jobCommentForm) {
    this.reloadTable.emit(false);
    let jobComment = new JobComment();
    jobComment.job = this.fields.id;
    if(this._authenticationService.currentUserValue){
        this.currentUser = this._authenticationService.currentUserValue['user'];
      }
    jobComment.createdBy=this.currentUser;
    jobComment.description = this.jobCommentForm.value.comments;
    jobComment.name = "N/A";
    this._jobCommentService.create(jobComment).subscribe(
      res => {
        this.newJobComment = res;
        if (res.id) {
          this.showJobCommentToast();
          this.jobCommentForm.reset();
          this.showDialog(false);
        }
      },
      (err) => {
        this._toastService.add({
          severity: 'error', summary: Messages.jobCommentError,
          detail: Messages.tryAgain
        }
        )
      }
    )

  }

  onLoad() {
    let queryParams = new Object();
    queryParams['sortParam'] = { 'sortField': "createdOn", 'sortOrder': -1 };
    queryParams['pageParam'] = {'page': this.first/this.pageSize, 'size': this.pageSize};
    let commentSortingQueryOption = new QueryOptions(queryParams);
    commentSortingQueryOption.queryMap.set('jobId', this.fields.id);
    commentSortingQueryOption.toQueryMap();
    this._jobCommentServiceGet.list(commentSortingQueryOption).subscribe(res => {
      this.records = res;
    });
  }


  showJobCommentToast = function () {
    this._toastService.add({ severity: 'success', summary: Messages.jobCommentSuccess, detail: '' });
  }

  showDialog = function (bool: boolean) {
    this.jobCommentForm.reset();
    this.displayFunction.emit(bool);
    this.reloadTable.emit(true);
  }

}



